import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { FormEvent, useState } from "react";

import { login as doLogin } from "../lib/auth";

export const Route = createFileRoute("/login")({
  component: LoginPage,
});

function LoginPage() {
  const nav = useNavigate();
  const [loginVal, setLogin] = useState("");
  const [pwd, setPwd] = useState("");
  const [err, setErr] = useState<string | null>(null);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setErr(null);
    try {
      await doLogin(loginVal, pwd);
    } catch {
      setErr("Credenciais inválidas");
      return;
    }
    nav({ to: "/" });
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "var(--surface-app)",
        padding: "0 16px",
      }}
    >
      <form
        onSubmit={onSubmit}
        style={{
          width: "100%",
          maxWidth: 360,
          background: "var(--surface-card)",
          border: "1px solid var(--line)",
          borderRadius: 12,
          padding: "28px",
          display: "flex",
          flexDirection: "column",
          gap: 14,
          boxShadow: "var(--shadow-modal)",
        }}
      >
        {/* placa de marca escura (a arte do logo é clara) */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 8,
            background: "var(--logo-plate)",
            borderRadius: 8,
            padding: "12px 14px",
            marginBottom: 6,
          }}
        >
          <img
            src="/logo-carmillion.avif"
            alt="Carmillion"
            style={{ height: 26, width: "auto", objectFit: "contain" }}
          />
          <span
            style={{
              fontFamily: "var(--font-display)",
              fontSize: 10,
              fontWeight: 700,
              letterSpacing: "0.08em",
              textTransform: "uppercase",
              color: "var(--brand-accent)",
              background: "rgba(225,72,72,0.12)",
              border: "1px solid rgba(225,72,72,0.38)",
              borderRadius: 4,
              padding: "2px 6px",
              flexShrink: 0,
            }}
          >
            Valquiria
          </span>
        </div>

        <input
          style={{
            width: "100%",
            padding: "9px 12px",
            background: "var(--surface-input)",
            border: "1px solid var(--line)",
            borderRadius: 8,
            color: "var(--ink)",
            fontSize: 14,
            outline: "none",
          }}
          placeholder="Login"
          name="login"
          autoComplete="username"
          aria-label="Login"
          value={loginVal}
          onChange={(e) => setLogin(e.target.value)}
          onFocus={(e) => (e.currentTarget.style.borderColor = "var(--brand)")}
          onBlur={(e) => (e.currentTarget.style.borderColor = "var(--line)")}
        />

        <input
          type="password"
          style={{
            width: "100%",
            padding: "9px 12px",
            background: "var(--surface-input)",
            border: "1px solid var(--line)",
            borderRadius: 8,
            color: "var(--ink)",
            fontSize: 14,
            outline: "none",
          }}
          placeholder="Senha"
          name="password"
          autoComplete="current-password"
          aria-label="Senha"
          value={pwd}
          onChange={(e) => setPwd(e.target.value)}
          onFocus={(e) => (e.currentTarget.style.borderColor = "var(--brand)")}
          onBlur={(e) => (e.currentTarget.style.borderColor = "var(--line)")}
        />

        {err && <p style={{ color: "var(--danger)", fontSize: 13 }}>{err}</p>}

        <button
          type="submit"
          style={{
            width: "100%",
            padding: "9px",
            background: "var(--brand)",
            color: "#fff",
            border: "none",
            borderRadius: 8,
            fontSize: 14,
            fontWeight: 500,
            cursor: "pointer",
          }}
          onMouseOver={(e) => (e.currentTarget.style.opacity = "0.85")}
          onMouseOut={(e) => (e.currentTarget.style.opacity = "1")}
        >
          Entrar
        </button>
      </form>
    </div>
  );
}
